import * as Yup from 'yup';
import * as moment from 'moment';
import { FORMAT, BIDFORMAT } from '../utils/dateOfBirthValidation';
export function getPostInitialValues(editResponse, multiSelectVal) {

  let requestDate = moment(new Date().setDate(new Date().getDate() + 3)).format(BIDFORMAT)

  let bidCloseDate = moment(new Date().setDate(new Date().getDate() + 1)).format(FORMAT)
  let bidCloseTime
  if (editResponse && editResponse?.postPreferences) {
    bidCloseTime = new Date(editResponse?.postPreferences?.bidCloseTime).toLocaleTimeString('en-US',{ hour12: false })//dateTime.format('HH:mm');
    bidCloseDate = new Date(editResponse?.postPreferences?.bidCloseTime).toLocaleDateString('en-US')//dateTime.format('MM/DD/YYYY');
  }
  
  let currentTimeBegin = new Date()
  currentTimeBegin.setHours(8)
  currentTimeBegin.setMinutes(0)

  let beginHours = currentTimeBegin.getHours();
  let beginMinutes = currentTimeBegin.getMinutes()
  let beginCurrentTime = beginHours + ':' + beginMinutes

  let currentTimeEnd = new Date()
  currentTimeEnd.setHours(17)
  currentTimeEnd.setMinutes(0)

  let endHours = currentTimeEnd.getHours();
  let endMinutes = currentTimeEnd.getMinutes()
  let endCurrentTime = endHours + ':' + endMinutes

  let deliveryWindowBegin = beginCurrentTime;
  let deliveryWindowEnd = endCurrentTime;


  let conditionValue
  if (editResponse?.palletDetails?.condition?.length > 0) {
    if (editResponse?.palletDetails?.condition[0] === 'RECYCLED') conditionValue = 'recycled'
    else if (editResponse?.palletDetails?.condition[0] === 'NEW') conditionValue = 'newCondition'
    else if (editResponse?.palletDetails?.condition[0] === 'COMBO') conditionValue = 'combo'
    else if (editResponse?.palletDetails?.condition[0] === 'CORES') conditionValue = 'cores'
  }

  let palletType;
  if(editResponse?.palletDetails?.palletType){
    if(editResponse?.palletDetails?.palletType === "Euro Pallet" || editResponse?.palletDetails?.palletType === "EUROPALLET"){
        palletType ='euroPallet'
    }else{
        palletType=editResponse?.palletDetails?.palletType.toLowerCase()
    }   
  }

  let deliveryLeadTime = editResponse?.deliveryLeadTime
  if(editResponse?.deliveryLeadTime === '24 hour(s)')
  deliveryLeadTime= '24'
  else if(editResponse?.deliveryLeadTime === '48 hour(s)')
  deliveryLeadTime= '48'
  else if(editResponse?.deliveryLeadTime === '72 hour(s)')
  deliveryLeadTime= '72'

  let displayCostToMarket
  if(editResponse && !editResponse?.displayCostToMarket){
    displayCostToMarket=false
  }else{
    displayCostToMarket = true
  }
  
  let heatTreared
  if(editResponse && !editResponse?.palletDetails?.heatTreared){
    heatTreared= false
  }else{
    heatTreared= true
  }


  // let locationType
  // if(localStorage.getItem('location') === "CORPORATE_SUBACC"){
  //   locationType='sub'
  // }else{
  //   if(editResponse){
  //     if(localStorage.getItem('locationId') === editResponse?.postedUserDetails?.locationId && localStorage.getItem('location') === "CORPORATE_ADMIN"){
  //       locationType='main'
  //     }else{
  //       locationType='sub'
  //     }
  //   }else{
  //     locationType='main'
  //   }   
  // }

  return {
    //Specification
    title: editResponse?.postTitle || '',
    description: editResponse?.comments || '',

    // pallet spec details
    hardOrSoftWood: (editResponse && editResponse?.palletDetails?.newConditionType === 'HARDWOOD') ? 'New - Hardwood' : editResponse?.palletDetails?.newConditionType === 'SOFTWOOD' ? 'New - Softwood' : '',
    materialRadioValue: editResponse?.palletDetails?.material ? editResponse?.palletDetails?.material?.toLowerCase() : 'wood',
    conditionRadioValue: conditionValue || '',
    palletType: palletType? palletType : '',
    isMoistureAvailable: false,
    isSizeAvailable: false,
    size: editResponse?.palletDetails?.size || '',
    isGradeAvailable: false,
    grade: editResponse?.palletDetails?.grade || '',
    moisture: editResponse?.palletDetails?.moisture || '',
    length: editResponse?.palletDetails?.length || '',
    width: editResponse?.palletDetails?.width || '',
    height: editResponse?.palletDetails?.height || '',
    showHeatTreated: editResponse?.palletDetails?.heatTreared || false,
    heatTreated: heatTreared,

    // Bidding
    lots: editResponse?.lotDetails?.lotPostingOption === 'MULTIPLE'? 1: editResponse?.lotDetails?.totLots? editResponse?.lotDetails?.totLots: '',
    quantityPerLot: editResponse?.lotDetails?.qtyPerLot || 540,
    quantityMaxValue: editResponse?.lotDetails?.originalQty || 540,
    totalQuantity: editResponse?.lotDetails?.totalQty || 540,
    
    pinwheel: false,
    costCheckBox: displayCostToMarket,
   
    basePrice: editResponse?.minDeliveredPrice || '',
    desiredPrice: editResponse?.buyNowDeliveredPrice || '',
    cpuPrice: editResponse?.buyNowPickupPrice || '',
    bidCloseTime: bidCloseDate,
    postLoadBidCloseTime: bidCloseTime || '08:00',

    bidAcceptanceMethod: editResponse?.postPreferences?.acceptanceMethod === 'AUTOMATIC' ? "ABOVE_TARGET_THRESHOLD" : 'APPROVE_AND_ACCEPT',
    isPostRecurring0: editResponse?.isPostRecurring ? editResponse.isPostRecurring : false,
    isPostRecurring1: editResponse?.isRecurring ? editResponse.isRecurring : false,

    //Delivery
    isDeliveryAvailable: editResponse?.shippingMode === 'PICKUP' ? 'false' : 'true',
    distanceWillingToTravel: editResponse?.distanceWillingToTravel || '',
    unitsDistanceTravel: editResponse?.unitsDistanceTravel || 'MILES',
    deliveryTime: deliveryLeadTime? deliveryLeadTime.toString() : '',
    deliveryTimeUnits: editResponse?.deliveryTimeUnits || 'HOURS',

    vehiclePreferences0: editResponse?.vehiclePreferences?.includes('FLAT_BED') ? true : '',
    vehiclePreferences1: editResponse?.vehiclePreferences?.includes('VAN') ? true : '',
    vehiclePreferences2: editResponse?.vehiclePreferences?.includes('STRAIGHT') ? true : '',

    lotPostingOption: editResponse?.lotDetails?.lotPostingOption === 'SINGLE' ? 'sellAll' : 'SplitByLot',
    lotsEdit: editResponse?.quantityPerLots || 540,
    lotsEditMaxValue: editResponse?.grade?.quantity || 540,
    lotsCheckBox: editResponse?.allowAltOffer || false,

    locationId: editResponse?.postedUserDetails?.locationId || '',
    locationType: 'main',
    

    // shipperName: editResponse?.userDetails?.companyName || '',
    // line1: editResponse?.userDetails?.address1 || '',
    // line2: editResponse?.userDetails?.address2 || '',
    // state: editResponse?.userDetails?.state || '',
    // city: editResponse?.userDetails?.city || '',
    // zip: editResponse?.userDetails?.zipCode || '',

    shipperName: editResponse?.shippingAddress?.locationName || '',
    line1: editResponse?.shippingAddress?.address1 || '',
    line2: editResponse?.shippingAddress?.address2 || '',
    state: editResponse?.shippingAddress?.state || '',
    city: editResponse?.shippingAddress?.city || '',
    zip: editResponse?.shippingAddress?.zipCode || '',

    brokerOperationDays: editResponse?.shippingAddress?.locationDaysOfOperations || [],
    brokerOperationStartTime: editResponse?.shippingAddress?.locationOfficeHourStart || '',
    brokerOperationEndTime: editResponse?.shippingAddress?.locationOfficeHourEnd || '',

    postingPlacePreference: editResponse?.postPreferences?.postingMethod || 'MARKET',
    postingMethod:  multiSelectVal?.length > 0 ? multiSelectVal : [],
    
    isPostRecurring: 'POST',
    notes: editResponse?.notes || '',
    officeHourStart: deliveryWindowBegin,
    officeHourEnd: deliveryWindowEnd,

    type: 'DAILY',
    dayOfWeek: 'Monday',
    daysOfWeek: [],
    interval: '1',
    theRadioInterval: '1',
    monthlyRadio: 'Day',
    noDay: '1',
    endAfterOccurrences: '1',
    recurrenceRadio: 'endAfter',
    start: requestDate,
    endBy: requestDate,

    index: 'FIRST',
    daysdropDown: 'MONDAY',

    referenceNumber: "",
    errorFields: []
  };
}

const VALIDATION_SCHEMA = (pageLanguageContents) => {
  let schemaAttributes
  schemaAttributes = {
    shipperName: Yup.string().trim().required('Company Name is required.'),
    line1: Yup.string().trim().required("Address 1 required"),
    city: Yup.string().trim().required("City is required"),
    zip: Yup.string().trim()
      .min(5, "Too Short")
      .required("Zip code required minimum 5 digit."),
    title: Yup.string().trim().required(pageLanguageContents?.ErrorValidations[0]?.TitleReq),
    totalQuantity: Yup.string().trim().required(pageLanguageContents?.ErrorValidations[2]?.QuantityReq),
    deliveryTime: Yup.string().trim().required('Delivery time is required.'),
    palletType: Yup.string().when('materialRadioValue',
      (materialRadioValue, schema) => {
        if (materialRadioValue === 'wood') return schema.required()
        else return schema
      }),
    conditionRadioValue: Yup.string().when('materialRadioValue',
      (materialRadioValue, schema) => {
        if (materialRadioValue === 'plastic' || materialRadioValue === 'wood') return schema.required()
        else return schema
      }),
    length: Yup.string().when('size',
      (size, schema) => {
        if (size === "Custom") return schema.required('Length is required.')
        else return schema
      }).when('materialRadioValue',
        (materialRadioValue, schema) => {
          if (materialRadioValue === 'plastic' || materialRadioValue === 'other') return schema.required('Length is required.')
          else return schema
        }),
    width: Yup.string().when('size',
      (size, schema) => {
        if (size === "Custom") return schema.required('Width is required.')
        else return schema
      }).when('materialRadioValue',
        (materialRadioValue, schema) => {
          if (materialRadioValue === 'plastic' || materialRadioValue === 'other') return schema.required('Width is required.')
          else return schema
        }),
    height: Yup.string().when('size',
      (size, schema) => {
        if (size === "Custom") return schema.required('Height is required.')
        else return schema
      }).when('materialRadioValue',
        (materialRadioValue, schema) => {
          if (materialRadioValue === 'plastic' || materialRadioValue === 'other') return schema.required('Height is required.')
          else return schema
        }),
  }
  return Yup.object().shape(schemaAttributes);
}

export { VALIDATION_SCHEMA };
